import React from 'react';
import Stepper from '@mui/material/Stepper';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { StyledUiStepper } from './UiStepper.styles';

const UiStepper = (props) => {
  const { children, className, activeStep, ...restProps } = props;

  let activeStepClassName = 'is-middle-steps-active';
  if (activeStep === 0) {
    activeStepClassName = 'is-first-step-active';
  } else if (activeStep === children.length - 1) {
    activeStepClassName = 'is-last-step-active';
  }

  return (
    <StyledUiStepper>
      <Stepper
        className={classNames(className, activeStepClassName)}
        {...restProps}
      >
        {children}
      </Stepper>
    </StyledUiStepper>
  );
};

UiStepper.propTypes = {
  className: PropTypes.string,
  activeStep: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default UiStepper;
